import { ImageProps, inmarketLogo } from '@features/powerpoint';
import {
  chartOutlineWhite,
  coinsInHandOutlineWhite,
  dollarSignSolidBlue,
  phoneInHandOutlineWhite,
  speedometerOutlineWhite,
  spinnerSolidWhite,
} from '../../images';

const taglineImage = (
  path: string,
  options: Exclude<ImageProps, 'path'> = {}
): ImageProps => ({
  path,
  h: 0.69,
  w: 0.69,
  x: 0.85,
  y: 2.83,
  ...options,
});

const lciBoxImage = (
  path: string,
  options: Exclude<ImageProps, 'path'> = {}
): ImageProps => ({
  path,
  h: 0.37,
  w: 0.37,
  x: 7.71,
  y: 4.08,
  ...options,
});

export const images: ImageProps[] = [
  {
    path: inmarketLogo,
    h: 0.39,
    w: 2.22,
    x: 7.51,
    y: 1.77,
  },
  taglineImage(chartOutlineWhite, {
    y: 2.83,
  }),
  taglineImage(coinsInHandOutlineWhite, {
    y: 4.15,
  }),
  taglineImage(speedometerOutlineWhite, {
    y: 5.48,
  }),
  lciBoxImage(phoneInHandOutlineWhite, {
    h: 0.59,
    w: 0.59,
    x: 7.59,
    y: 2.93,
  }),
  lciBoxImage(spinnerSolidWhite, {
    y: 4.08,
  }),
  lciBoxImage(dollarSignSolidBlue, {
    y: 5.02,
  }),
];
